import _ from 'lodash'
import { List, Map, isImmutable } from 'immutable'
import * as actionTypes from './actionTypes'
import { getAxios, getPreviewDynamicData, isDisabledSfIntegration } from '../../lib/projectAxios'
import { formatSFMappingResult, processActionsSFItem } from '../../lib/common'
import { setVisibilityOfSFMappingElem } from '../../lib/setVisibilityOfSFMappingElem'
import { getParams, getDefaultParams, getState, getPapamFrom, updateOldValue } from '../../lib/processPortalRules'
import { recursivePreparePortalSFMapping } from './recursivePreparePortalSFMapping'
import { allowCoBrowse, SURVEY_TYPE } from '../../constants/features'
import { isAllowProcessSFFetchCacheData, processSFFetchCacheData } from './pwa-tools'
import { waitProcessingPickList } from './recursivePrepareSFMapping'

const axios = getAxios()
let autoTriggerTimer = null
export const processSFAutoTrigger =
  (onLoad = false, step = 0, onOpenProject, repeatIndex) =>
  async (dispatch, getCurrentState) => {
    if (autoTriggerTimer) {
      clearTimeout(autoTriggerTimer)
    }
    if (!onLoad && (repeatIndex === null || repeatIndex === undefined)) {
      autoTriggerTimer = setTimeout(() => {
        dispatch(_processSFAutoTrigger(onLoad, step, onOpenProject, repeatIndex))
        autoTriggerTimer = null
      }, 600)
    } else {
      dispatch(_processSFAutoTrigger(onLoad, step, onOpenProject, repeatIndex))
    }
  }

export const _processSFAutoTrigger =
  (onLoad = false, step = 0, onOpenProject, repeatIndex) =>
  async (dispatch, getCurrentState) => {
    if (step >= 30) {
      return false
    }
    const prevDD = getPreviewDynamicData() || {}
    const isUserSignIn = Boolean(prevDD.user || prevDD.messageValue)
    let state = getCurrentState()

    if (allowCoBrowse) {
      if (
        state.getIn(['project', 'Settings', 'coBrowse', 'mode'], 'user') !== 'user' &&
        state.getIn(['project', 'Settings', 'coBrowse', 'status'], false)
      ) {
        return null
      }
    }

    const currState = getState(state)
    const defaultParams = getDefaultParams(state)
    const currParams = getParams(state)
    let dep = {}

    let integration
    let loadingMessages = [],
      isNeedRecall = false
    if (state.getIn(['autoTrigStatus'], false) === true) {
      return false
    }
    dispatch({ type: actionTypes.PROCESS_AUTO_START })
    const sfMapping = state.getIn(['project', 'Settings', 'sfMapping'], Map()).toJS()
    let isProcessPickListLoad = false
    let pickListCurrentRequest = {}
    if (!_.isEmpty(sfMapping)) {
      _.each(sfMapping, (item, key) => {
        let isUseSmartV = false
        const isUserAction = item.type === 'custom'
        if (item.type === 'trigger' || (item.isSyncLoadPickList && !isUserAction)) {
          let isEffectedMapping = false,
            isAllMapped = true
          _.each(item.fields, (field) => {
            const key = String(field.value).replace(/:/g, '.')
            if (
              _.startsWith(field.group, 'formWidget:') ||
              _.startsWith(field.group, 'listWidget:') ||
              _.startsWith(field.group, 'tableWidget:')
            ) {
              dep[key] = dep[key] || {}
              dep[key][field.value] = _.get(currState, key, null)
              let oldVal = state.getIn(['autotrigger', key, field.value])
              if (isImmutable(oldVal)) {
                oldVal = oldVal.toJS()
              }
              if (oldVal && typeof oldVal === 'object') {
                oldVal = JSON.stringify(oldVal)
              }
              let newVal = _.get(currState, key, null)
              if (newVal && typeof newVal === 'object') {
                newVal = JSON.stringify(newVal)
              }
              if (newVal !== oldVal) {
                // console.log('come >>>>> ', _.get(currState, key, null));
                isEffectedMapping = true
              }
              if (onLoad && (dep[key][field.value] === null || dep[key][field.value] === '')) {
                isEffectedMapping = false
              }
            } else if (_.startsWith(field.group, 'form:')) {
              dep[key] = dep[key] || {}
              dep[key][field.value] = _.get(currState, field.value, null)
              if (_.get(currState, field.value, null) !== state.getIn(['autotrigger', key, field.value])) {
                isEffectedMapping = true
              }
              if (onLoad && (dep[key][field.value] === null || dep[key][field.value] === '')) {
                isEffectedMapping = false
              }
            } else if (field.group === 'param') {
              dep[key] = dep[key] || {}
              dep[key][field.value] = getPapamFrom(currParams, field.value, null)
              if (onLoad) {
                if (getPapamFrom(currParams, field.value, null) !== getPapamFrom(defaultParams, field.value, null)) {
                  isEffectedMapping = true
                }
              } else {
                if (
                  getPapamFrom(currParams, field.value, null) !== state.getIn(['autotrigger', key, field.value], '')
                ) {
                  isEffectedMapping = true
                }
              }
            } else if (field.group === 'smartv') {
              dep[key] = dep[key] || {}
              dep[key][field.value] = isUserSignIn ? 'true' : ''
              isUseSmartV = true
              if (onLoad) {
                if (isUserSignIn) {
                  isEffectedMapping = true
                } else {
                  isEffectedMapping = false
                }
              } else {
                if (state.getIn(['autotrigger', key, field.value]) !== dep[key][field.value]) {
                  isEffectedMapping = true
                }
              }
            } else if (field.group.indexOf('params') !== -1) {
              const paramID = _.last(field.value.split('.'))
              dep[key] = dep[key] || {}
              dep[key][field.value] = getPapamFrom(currParams, paramID, null)
              if (onLoad) {
                if (getPapamFrom(currParams, field.value, null) !== getPapamFrom(defaultParams, field.value, null)) {
                  isEffectedMapping = true
                }
              } else {
                if (getPapamFrom(currParams, field.value, null) !== state.getIn(['autotrigger', key, field.value])) {
                  isEffectedMapping = true
                }
              }
            } else if (field.group === 'smartv') {
              dep[key] = dep[key] || {}
              dep[key][field.value] = _.get(prevDD, `svParams.${field.value}`, null)
              if (
                dep[key][field.value] !== null &&
                dep[key][field.value] !== state.getIn(['autotrigger', key, field.value])
              ) {
                isEffectedMapping = true
              }
            } else if (_.startsWith(field.group, 'view:')) {
              const key = String(updateOldValue(field.value)).replace(/:/g, '.')
              dep[key] = dep[key] || {}
              dep[key][field.value] = _.get(currState, key, null)
              if (
                _.get(currState, key, null) &&
                _.get(currState, key, null) !== state.getIn(['autotrigger', key, field.value])
              ) {
                isEffectedMapping = true
              }
              if (onLoad && (dep[key][field.value] === null || dep[key][field.value] === '')) {
                isEffectedMapping = false
              }
            } else {
              const key = String(field.value).replace(/:/g, '.')
              dep[key] = dep[key] || {}
              dep[key][field.value] = _.get(currState, key, null)
              if (
                _.get(currState, key, null) &&
                _.get(currState, key, null) !== state.getIn(['autotrigger', key, field.value])
              ) {
                isEffectedMapping = true
              }
              if (onLoad && (dep[key][field.value] === null || dep[key][field.value] === '')) {
                isEffectedMapping = false
              }
            }
          })
          if (isUseSmartV && !isUserSignIn) {
            isEffectedMapping = false
          }
          if (isEffectedMapping && isAllMapped) {
            if (!integration) {
              integration = {
                list: {},
              }
            }
            try {
              if (item.isSyncLoadPickList) {
                isProcessPickListLoad = true
                if (!window.ftProcessingLoadPickList) {
                  window.ftProcessingLoadPickList = {}
                }
                if (!window.ftProcessingLoadPickList[key]) {
                  window.ftProcessingLoadPickList[key] = {
                    jobs: {},
                    step: 0,
                  }
                }
                window.ftProcessingLoadPickList[key].step++
                let currentStep = window.ftProcessingLoadPickList[key].step
                window.ftProcessingLoadPickList[key].jobs[currentStep] = 'processing'
                pickListCurrentRequest[key] = currentStep
              }
            } catch (err) {
              console.error(err)
            }
            integration.list[key] = item
          }
        }
      })
      dispatch({
        type: actionTypes.PROCESS_AUTO_TRIGGER,
        payload: {
          dep,
        },
      })
      if (integration) {
        let projectState = currState || {}
        integration.list = recursivePreparePortalSFMapping(
          integration.list,
          projectState,
          currParams,
          loadingMessages,
          false
        )
        if (!_.isEmpty(integration.list)) {
          try {
            if (isDisabledSfIntegration('get', integration.list)) {
              return false
            }
          } catch (err) {
            console.error(err)
          }

          if (!loadingMessages.length > 0) {
            dispatch({
              type: actionTypes.SHOW_LOADING_WINDOW,
              payload: {
                messages: loadingMessages,
              },
            })
          }

          try {
            if (repeatIndex === null || repeatIndex === undefined) {
              setVisibilityOfSFMappingElem(sfMapping, integration.list, true, true, state, dispatch)
            }

            processActionsSFItem(sfMapping, integration.list, true, 'duringIntegration', dispatch)

            if (state.get('IS_ALLOW_DEBUG_MODE', false)) {
              console.log('auto trigger >>> ', Object.keys(integration.list))
            }

            if (isAllowProcessSFFetchCacheData(state)) {
              return dispatch(processSFFetchCacheData(integration.list, repeatIndex))
            }

            let { status, data } = await axios.post('/webprojects/get/sfmapping', {
              data: {
                list: integration.list,
              },
            })
            try {
              await waitProcessingPickList(isProcessPickListLoad, pickListCurrentRequest)
            } catch (err) {
              console.error(err.stack)
            }

            // data = formatSFMappingResult(data);

            let isShowLoading = false
            let loadingMessages = {}
            if (data && data.messages && Object.keys(_.omit(data.messages, ['canceled'])).length) {
              isShowLoading = true
              loadingMessages.type = 'error'
              loadingMessages.isAlloClose = true
              loadingMessages.list = []
              _.each(_.omit(data.messages, ['canceled']), (msg) => {
                loadingMessages.list.push(msg)
              })
            }
            dispatch({
              type: actionTypes.PROCESS_SF_MAPPING,
              payload: {
                data,
                list: integration.list,
                repeatIndex: repeatIndex,
                isShowLoading,
                loadingMessages,
                sfMessages: data ? _.omit(data.messages, ['canceled']) : {},
              },
            })
            dispatch({
              type: actionTypes.PROCESS_VISIBILITY_SF_MAPPING,
              payload: {
                list: integration.list,
                params: data.messages,
              },
            })

            if (state.getIn(['project', 'ProjectType'], 'web') === SURVEY_TYPE) {
              dispatch({
                type: actionTypes.PROCESS_SF_SURVEY_MAPPING,
                payload: {},
              })
            }
          } catch (error) {
            console.log('>>>', error)
            dispatch({
              type: actionTypes.FETCH_DATA_ERROR,
              payload: {
                error: 'An error occurred, try again later',
              },
            })
            dispatch({
              type: actionTypes.CLOSE_LOADING_WINDOW,
            })
          }
        }
      }
    }
    dispatch({ type: actionTypes.PROCESS_AUTO_END })
    const sys = getCurrentState().getIn(['sys'], List())
    dispatch({ type: actionTypes.CLEAR_RECENT_UPDATES })
    if (sys.size > 0) {
      dispatch(processSFAutoTrigger(false, step + 1))
    }
  }
